import Vue from "vue";
import Router from "vue-router";
import TokenService from "@/service/token.service.js";
Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "dashboard",
            component: () =>
                import(/* webpackChunkName: "dashboard" */ "./views/Dashboard.vue")
        },
        {
            path: "/company/list",
            name: "companies",
            component: () =>
                import(/* webpackChunkName: "company-list" */ "./views/Company/List.vue")
        },
        {
            path: "/company/edit/:company?",
            name: "company.edit",
            props: true,
            component: () =>
                import(/* webpackChunkName: "company-edit" */ "./views/Company/Edit.vue")
        },
        {
            path: "/company/:company/shift/edit/:shift?",
            name: "company.shift.edit",
            props: true,
            component: () =>
              import(/* webpackChunkName: "company-shift-edit" */ "./views/Company/Shift/Edit.vue")
        },
        {
            path: "/company/locations",
            name: "company.locations",
            component: () =>
                import(/* webpackChunkName: "company.locations.list" */ "./views/Company/Location/List.vue")
        },
        {
            path: "/company/location/edit/:location?",
            name: "company.location.edit",
            props: true,
            component: () =>
                import(/* webpackChunkName: "company.locations.list" */ "./views/Company/Location/Edit.vue")
        },
        {
            path: "/product/list",
            name: "products",
            component: () =>
                import(/* webpackChunkName: "product-list" */ "./views/Product/List.vue")
        },
        {
            path: "/product/edit/:product?",
            name: "product.edit",
            props: true,
            component: () =>
                import(/* webpackChunkName: "company-edit" */ "./views/Product/Edit.vue")
        },
        {
            path: "/product/category/list",
            name: "product.categories",
            component: () =>
                import(/* webpackChunkName: "product-categories-list" */ "./views/Product/Category/List.vue")
        },
        {
            path: "/product/category/edit/:category?",
            name: "product.category.edit",
            props: true,
            component: () =>
                import(/* webpackChunkName: "product-category-edit" */ "./views/Product/Category/Edit.vue")
        },
        {
            path: "/product/allergen/list",
            name: "product.allergens",
            component: () =>
                import(/* webpackChunkName: "product-allergen-list" */ "./views/Product/Allergen/List.vue")
        },
        {
            path: "/product/allergen/edit/:allergen?",
            name: "product.allergen.edit",
            props: true,
            component: () =>
                import(/* webpackChunkName: "product-allergen-edit" */ "./views/Product/Allergen/Edit.vue")
        },
        {
            path: "/user/profile",
            name: "user.profile",
            component: () =>
                import(/* webpackChunkName: "user-profile" */ "./views/User/Profile.vue")
        },
        {
            path: "/user/list",
            name: "users",
            component: () =>
                import(/* webpackChunkName: "user-list" */ "./views/User/List.vue")
        },
        {
            path: "/user/add/csv",
            name: "users.csv",
            component: () =>
                import(/* webpackChunkName: "add-users-csv" */ "./views/User/AddUsersCsv.vue")
        },
        {
            path: "/user/edit/:user?",
            name: "user.edit",
            props: true,
            component: () =>
                import(/* webpackChunkName: "user-edit" */ "./views/User/Edit.vue")
        },
        {
            path: "/menu/template/list",
            name: "menu.templates",
            component: () =>
                import(/* webpackChunkName: "menu-templates-list" */ "./views/Menu/Template/List.vue")
        },
        {
            path: "/menu/template/edit/:template?",
            name: "menu.template.edit",
            props: true,
            component: () =>
                import(/* webpackChunkName: "menu-template-edit" */ "./views/Menu/Template/Edit.vue")
        },
        {
            path: "/menu/companies",
            name: "menus",
            component: () =>
                import(/* webpackChunkName: "menus-list" */ "./views/Menu/View.vue")
        },
        {
            path: "/menu/daily/:company",
            name: "daily.company.menu",
            props: true,
            component: () =>
                import(/* webpackChunkName: "menus-daily-company" */ "./views/Menu/Company.vue")
        },
        {
            path: "/reports/preorders",
            name: "reports.preorders",
            props: true,
            component: () =>
                import(/* webpackChunkName: "reports-preorders" */ "./views/Reports/Preorders.vue")
        },
        {
            path: "/reports/labels",
            name: "reports.labels",
            props: true,
            component: () =>
                import(/* webpackChunkName: "reports-labels" */ "./views/Reports/Labels.vue")
        },
        {
            path: "/reports/checkin",
            name: "reports.checkin",
            props: true,
            component: () =>
                import(/* webpackChunkName: "reports-labels" */ "./views/Reports/Checkin.vue")
        },
        {
            path: "/reports/sales",
            name: "reports.sales",
            props: true,
            component: () =>
                import(/* webpackChunkName: "reports-labels" */ "./views/Reports/Sales.vue")
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((from, to, next) => {
    if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        // parse meta tags
        Vue.prototype.$Progress.parseMeta(meta);
    }
    Vue.prototype.$Progress.start();

    const loggedIn = !!TokenService.get();

    console.log(loggedIn);
    const role = !!TokenService.getRole();
    if (!loggedIn || !role) {
        TokenService.removeAll();
        window.location.href = `${process.env.VUE_APP_URL_AUTH}/login`;
    } else {
        next();
    }
});

router.afterEach(() => {
    Vue.prototype.$Progress.finish();
});

export default router;
